import React, { useEffect, useState, useCallback } from "react";
import { getPayableListing } from "../../../Bookclosure/Services/ApiHandler";
import Pagination from "./Pagination";
import styles from "./Table.module.css";

const PayableTable = ({ PayableID })  => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);

    const formatHeading = (text) =>
       text
         .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
         .replace(/([a-z])([A-Z])/g, "$1 $2")
         .trim();
   
     const loadData = useCallback(async () => {
       try {
         const response = await getPayableListing(PayableID, {
           page: currentPage,
           pageSize: rowsPerPage,
         });
   
         const res = response.data;
   
         setColumns(res.payableListingHeaders);
         setData(res.payableListing);
         setTotalPages(res.totalPages);
       } catch (error) {
         console.error("Error loading data:", error);
       }
     }, [PayableID, currentPage, rowsPerPage]);
   
     useEffect(() => {
       loadData();
     }, [loadData]); 
   
  return (
    <div className={styles.wrapper}>
     <div className={styles.tableContainer}>
       <table className={styles.table}>
         <thead>
           <tr>
             {columns.map((col) => (
              <th key={col}>{formatHeading(col)}</th>
             ))}
           </tr>
         </thead>
        
         <tbody>
           {data.map((row, i) => (
            <tr key={i}>
              {columns.map((col) => (
                <td key={col}>{row[col] ?? "-"}</td>
              ))}
            </tr>
           ))}
         </tbody>
       </table>
     </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
}

export default PayableTable;